import { render, staticRenderFns } from "./pointInfo.vue?vue&type=template&id=27a3f607&scoped=true&"
import script from "./pointInfo.vue?vue&type=script&lang=js&"
export * from "./pointInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a3f607",
  null
  
)

export default component.exports